import React from 'react';
import { GoBackButton } from './Utilities';
import emailjs from 'emailjs-com';


emailjs.init('service_jkzqk5m');

const Email = () => {
  return (
    <div>
      <div className='secondary-header'>
        <h1 className="main-text" style={{ fontSize: '43px', textAlign: 'left', backgroundColor: 'white', margin: '10vh 8vw', fontFamily: 'Atteron' }}>Contact ME/ <br />Hire Me</h1>
        <div style={{ margin: '15vh 15vw' }}> <GoBackButton /> </div>
      </div>
      <form className="contact-form" onsubmit="sendEmail(event)">
        <input className='email-form right-side-btn' type="text" name="user_name" placeholder="Your Name" required />
        <input className='email-form right-side-btn' type="email" name="user_email" placeholder="Your Email" required />
        <input className='email-form right-side-btn' style={{padding:'5vh'}} name="message" placeholder="Your Message" required />
        <button className='main-page-btns right-side-btn' type="submit">Send</button>
      </form>
    </div>
  );
};

export default Email;